<div class="table_action_header mt-3">
  <div class="table_action_header_left">
    <label class="name_label"> Tag Code </label>
  </div>
  <div class="table_action_header_right">
    <i class="material-icons pointer-cursor" (click)="closePopUp()"> close </i>
  </div>
</div>

<div class="ms-2 mt-2">
  <p><b>Set up instructions:</b></p>
  <div class="field-name">
    <ng-container *ngIf="data.type == 'universal-pixel'; else conversionPixel">
      <ol>
        <li>
          If the tag is intended for site-wide implementation, insert the code
          snippet into the
          <code class="active">&lt;footer&gt;</code> section of the website.
        </li>
        <li>
          For implementation on specific or selected pages, place the code
          within the <code class="active">&lt;body&gt;</code> section of the
          corresponding pages.
        </li>
      </ol>
    </ng-container>
    <ng-template #conversionPixel>
      <ol>
        <li>
          Place the tag on your website conversions or thank you page just
          before closing <code class="active">&lt;body&gt;</code> to track
          conversions accurately.
        </li>
      </ol>
    </ng-template>
  </div>
  <textarea disabled="true" rows="13" class="text" [(ngModel)]="tagCode">
  </textarea>
  <mat-icon
    matTooltip="Copy code"
    class="pointer-cursor align-copy-icon mb-2"
    cdkCopyToClipboard="tagCode"
    (click)="copyToClipboard()"
    >content_copy</mat-icon
  >
</div>
